document.addEventListener('DOMContentLoaded', () => {
  let loading = false
  let flkty

  if (!customElements.get('free-gift-progress')) {
    customElements.define('free-gift-progress', class FreeGiftProgress extends HTMLElement {
      constructor() {
        super()
        this.progressSettings = JSON.parse(this.querySelector('#free-gift-tier-amount').innerHTML)

        this.cartTotalPrice = this.progressSettings.cartTotalPrice + this.progressSettings.thresholdAmount
        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.querySelector('#free-gift-multiple-bar')) {
          this.onUpdateMultipleBar()
        } else {
          this.onUpdateOneBar()
        }
      }

      progressSettings = {}
      cartItems = {}
      cartTotalPrice = 0

      onUpdateMultipleBar() {
        const rate = Number(window.Shopify.currency.rate)
        const currency = this.progressSettings.currency

        let oneText = ''
        let oneWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierOneAmount * rate) {
          const oneAmount = this.progressSettings.tierOneAmount * rate

          if (this.querySelector('[for="tier-one-currency"]'))
            this.querySelector('[for="tier-one-currency"]').innerHTML = currency + (oneAmount / 100).toFixed(2)

          oneText = this.progressSettings.tierOneText.replace('$money', currency + ((this.progressSettings.tierOneAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
          oneWidth = this.cartTotalPrice / (this.progressSettings.tierOneAmount * rate) * 100
        } else {
          oneText = this.progressSettings.tierOneFullfilText
          oneWidth = 100
        }
        if (this.querySelector('#tier-one-bar'))
          this.querySelector('#tier-one-bar').style.width = `${oneWidth}%`

        if (this.querySelector('#tier-one-fullfil-text') && oneWidth === 100) {
          this.querySelector('#tier-one-fullfil-text').innerHTML = oneText
        } else if (this.querySelector('#tier-one-text')) {
          this.querySelector('#tier-one-text').innerHTML = oneText
        }

        let twoText = ''
        let twoWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierTwoAmount * rate) {
          const twoAmount = this.progressSettings.tierTwoAmount * rate

          if (this.querySelector('[for="tier-two-currency"]'))
            this.querySelector('[for="tier-two-currency"]').innerHTML = currency + (twoAmount / 100).toFixed(2)

          twoText = this.progressSettings.tierTwoText.replace('$money', currency + ((twoAmount - this.cartTotalPrice) / 100).toFixed(2))
          twoWidth = this.cartTotalPrice / (this.progressSettings.tierTwoAmount * rate) * 100
        } else {
          twoText = this.progressSettings.tierTwoFullfilText
          twoWidth = 100
        }

        if (this.querySelector('#tier-two-bar'))
          this.querySelector('#tier-two-bar').style.width = `${twoWidth}%`

        if (this.querySelector('#tier-two-fullfil-text') && twoWidth === 100) {
          this.querySelector('#tier-two-fullfil-text').innerHTML = twoText
        } else if (this.querySelector('#tier-two-text')) {
          this.querySelector('#tier-two-text').innerHTML = twoText
        }

        let threeText = ''
        let threeWidth = ''
        if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate) {
          const threeAmount = this.progressSettings.tierThreeAmount * rate

          if (this.querySelector('[for="tier-three-currency"]'))
            this.querySelector('[for="tier-three-currency"]').innerHTML = currency + (threeAmount / 100).toFixed(2)

          threeText = this.progressSettings.tierThreeText.replace('$money', currency + ((threeAmount - this.cartTotalPrice) / 100).toFixed(2))
          threeWidth = this.cartTotalPrice / (this.progressSettings.tierThreeAmount * rate) * 100
        } else {
          threeText = this.progressSettings.tierThreeFullfilText
          threeWidth = 100
        }
        if (this.querySelector('#tier-three-bar'))
          this.querySelector('#tier-three-bar').style.width = `${threeWidth}%`

        if (this.querySelector('#tier-three-fullfil-text') && threeWidth === 100) {
          this.querySelector('#tier-three-fullfil-text').innerHTML = threeText
        } else if (this.querySelector('#tier-three-text')) {
          this.querySelector('#tier-three-text').innerHTML = threeText
        }
      }

      isFirstInCart() {
        const firstProduct = document.querySelectorAll('free-gift-product')[0]
        if (firstProduct) {
          let productData = JSON.parse(firstProduct.querySelector('#free-products').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const variant of productData)
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                return true
              }
          }
        }

        return false
      }

      onUpdateOneBar() {
        let text = ''
        const rate = Number(window.Shopify.currency.rate)
        const currency = this.progressSettings.currency
        let maxAmount = this.progressSettings.showTierFour ?
          this.progressSettings.tierFourAmount
          : this.progressSettings.tierThreeAmount

        if (maxAmount === 0) {
          maxAmount = this.progressSettings.tierOneAmount
        }

        let width = this.cartTotalPrice / (maxAmount * rate) * 100

        const oneLeft = (this.progressSettings.tierOneAmount / maxAmount) * 100
        const twoLeft = (this.progressSettings.tierTwoAmount / maxAmount) * 100
        const threeLeft = (this.progressSettings.tierThreeAmount / maxAmount) * 100

        if (this.querySelector('#one-bar-tier-one-title .money'))
          this.querySelector('#one-bar-tier-one-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierOneAmount * rate / 100).toFixed(2)}`
        if (this.querySelector('#one-bar-tier-two-title .money'))
          this.querySelector('#one-bar-tier-two-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierTwoAmount * rate / 100).toFixed(2)}`
        if (this.querySelector('#one-bar-tier-three-title .money'))
          this.querySelector('#one-bar-tier-three-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierThreeAmount * rate / 100).toFixed(2)}`
        if (this.querySelector('#one-bar-tier-four-title .money'))
          this.querySelector('#one-bar-tier-four-title .money').innerHTML = `${currency}${Number(this.progressSettings.tierFourAmount * rate / 100).toFixed(2)}`

        if (this.querySelector('[data-tier="one"]'))
          this.querySelector('[data-tier="one"]').style.left = `${oneLeft}%`

        if (this.querySelector('#one-bar-tier-one-title')) {
          // 如果free shipping是0，左对其
          if (this.progressSettings.tierOneAmount === 0) {
            this.querySelector('#one-bar-tier-one-title').style.left = `${0}%`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`
            // 如果free gift是0，左对齐
          } else if (this.progressSettings.tierThreeAmount === 0) {
            this.querySelector('#one-bar-tier-one-title').style.right = `${0}%`
            this.querySelector('#one-bar-tier-one-title').style.left = `unset`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`
          } else {
            this.querySelector('#one-bar-tier-one-title').style.left = `unset`
            this.querySelector('#one-bar-tier-one-title').style.position = `unset`
            this.querySelector('#one-bar-tier-one-title').style.transform = `none`

            if (this.querySelector('#one-bar-tier-three-title')) {
              this.querySelector('#one-bar-tier-three-title').style.left = `unset`
              this.querySelector('#one-bar-tier-three-title').style.position = `unset`
              this.querySelector('#one-bar-tier-three-title').style.transform = `none`
            }

            if (this.querySelector('#one-bar-tier-four-title')) {
              this.querySelector('#one-bar-tier-four-title').style.left = `unset`
              this.querySelector('#one-bar-tier-four-title').style.position = `unset`
              this.querySelector('#one-bar-tier-four-title').style.transform = `none`
            }

            this.querySelector('.one-bar-text-wrapper').style.display = "flex"
            this.querySelector('.one-bar-text-wrapper').style.justifyContent = "flex-end"
            this.querySelector('.one-bar-text-wrapper').style.gap = "10px"
          }
        }

        if (this.progressSettings.showTierFour) {
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.left = `${twoLeft}%`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title').style.left = `${50}%`
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.left = `${threeLeft}%`
          if (this.querySelector('#one-bar-tier-three-title'))
            this.querySelector('#one-bar-tier-three-title').style.left = `${50}%`

          if (this.querySelector('#one-bar-tier-four-title'))
            this.querySelector('#one-bar-tier-four-title').style.right = `0`
          if (this.querySelector('#one-bar-tier-four-title'))
            this.querySelector('#one-bar-tier-four-title').style.transform = `translateX(0)`
        } else {
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.display = 'none'
          if (this.querySelector('#one-bar-tier-three-title')) {
            this.querySelector('#one-bar-tier-three-title').style.right = `${0}%`
            this.querySelector('#one-bar-tier-three-title').style.transform = `translateX(0)`
          }
        }

        if (this.cartTotalPrice < this.progressSettings.tierOneAmount * rate) {
          text = this.progressSettings.tierOneText.replace('$money', currency + ((this.progressSettings.tierOneAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
        } else if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate || !this.progressSettings.showTierFour) {
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]'))
            this.querySelector('[data-tier="one"]').style.background = `white`
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')

          // 不显示第二个free gift
          if (this.cartTotalPrice < this.progressSettings.tierThreeAmount * rate) {
            text = this.progressSettings.tierThreeText.replace('$money', currency + ((this.progressSettings.tierThreeAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
          } else {
            text = this.progressSettings.tierThreeFullfilText.replace(this.isFirstInCart() ? 'Add to bag below.' : '', '')
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          }
        } else if (this.cartTotalPrice < this.progressSettings.tierFourAmount * rate && this.progressSettings.showTierFour) {
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]'))
            this.querySelector('[data-tier="one"]').style.background = `white`
          if (this.querySelector('[data-tier="two"]'))
            this.querySelector('[data-tier="two"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-two-title'))
            this.querySelector('#one-bar-tier-two-title')?.classList.add('fullfil')
          if (this.querySelector('[data-tier="three"]'))
            this.querySelector('[data-tier="three"]').style.background = `white`
          if (this.querySelector('#one-bar-tier-three-title'))
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          text = this.progressSettings.tierFourText.replace('$money', currency + ((this.progressSettings.tierFourAmount * rate - this.cartTotalPrice) / 100).toFixed(2))
        } else {
          text = !this.isFirstInCart() ? this.progressSettings.tierThreeFullfilText : this.progressSettings.tierFourFullfilText
          if (this.querySelector('#one-bar-tier-one-title'))
            this.querySelector('#one-bar-tier-one-title').classList.add('fullfil')
          if (this.querySelector('[data-tier="one"]')) {
            this.querySelector('[data-tier="one"]').style.background = `white`
          }
          if (this.querySelector('[data-tier="two"]')) {
            this.querySelector('[data-tier="two"]').style.background = `white`
            this.querySelector('#one-bar-tier-two-title').classList.add('fullfil')
          }
          if (this.querySelector('[data-tier="three"]')) {
            this.querySelector('[data-tier="three"]').style.background = `white`
            this.querySelector('#one-bar-tier-three-title')?.classList.add('fullfil')
          }
          this.querySelector('#one-bar-tier-four-title')?.classList.add('fullfil')

          width = 100
        }

        if (this.querySelector('#one-bar-text')) {
          this.querySelector('#one-bar-text').innerHTML = text;
          this.querySelector('#one-bar-progress').style.width = `${width}%`;
        }
      }
    })
  }

  if (!customElements.get('free-gift-product')) {
    customElements.define('free-gift-product', class FreeGiftProduct extends HTMLElement {
      constructor() {
        super()
        this.rate = Number(window.Shopify.currency.rate)

        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        this.cartTotalPrice = this.cartItems.total_price + Number(this.getAttribute('data-threshold-amount'))
        this.freeProductData = JSON.parse(this.querySelector('#free-products').innerHTML)
        this.freeProductAmount = Number(this.getAttribute('data-free-number')) * this.rate

        if (this.cartTotalPrice >= this.freeProductAmount) {
          this.querySelectorAll('.add-btn').forEach(item => item.classList.remove('disabled'))
          this.querySelectorAll('.product-name').forEach(item => item.classList.toggle('hidden'))
          this.querySelectorAll('.product-description').forEach(item => item.classList.toggle('hidden'))
        }

        const json = JSON.parse(this.querySelector('#free-product-json').innerHTML)
        this.freeGiftJson = json
        this.setText(json)

        if (this.freeGiftJson.variantType === 'select') {
          this.querySelectorAll('.free-gift-select select').forEach(item => item.addEventListener('change', event => this.onVarBtnSelect(event)))
        } else {
          this.querySelectorAll('.free-gift-varitant-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        }

        if (this.freeGiftJson.addToType === 'add-btn') {
          this.querySelectorAll('.free-gift-product-buy').forEach(item => item.addEventListener('click', (event) => this.onAddBtnClick(event)))
        }


        this.onCartUpdate()
      }

      flkty = null
      rate = 0
      freeGiftJson = {}
      cartTotalPrice = 0
      cartItems = {}
      freeProductAmount = 0
      freeProductData = []
      hasFreeProductInCart = false

      setText(data) {
        const freeAmount = Number(data.freeAmount * this.rate)
        const currency = this.freeGiftJson.currency

        if (this.querySelector('#free-product-title'))
          this.querySelector('#free-product-title').innerHTML = data.freeProductTitle.replace('$money', currency + (freeAmount / 100).toFixed(2))

        if (freeAmount > this.cartItems.total_price) {
          const unlockAmount = (freeAmount - this.cartItems.total_price) / 100
          if (this.querySelector('#free-product-subtitle'))
            this.querySelector('#free-product-subtitle').innerHTML = data.freeProductSubtitle.replace('$money', currency + unlockAmount.toFixed(2))

          if (this.freeGiftJson.addToType === 'add-btn')
            this.querySelector('#free-product-btn span').innerHTML = data.freeUnlockText.replace('$money', currency + unlockAmount.toFixed(2))
        } else if (this.freeGiftJson.addToType === 'add-btn') {
          this.querySelector('#free-product-btn span').innerHTML = 'ADD FREE GIFT TO ORDER'
        }
      }

      onVarBtnSelect(event) {
        if (loading) {
          return
        }

        if (this.freeGiftJson.addToType !== 'add-btn') {
          const id = event.target.value
          loading = true
          event.target.closest('div').classList.add('free-gift-loading')
          CartJS.addItem(id)
        }
      }

      onCartUpdate() {
        const index = Number(this.getAttribute('data-index'))
        let isFirstInCart = false
        let isSecondInCart = false

        const secondProduct = document.querySelectorAll('free-gift-product')[1]

        document.querySelectorAll('.header__cart__status').forEach(item => {
          item.innerHTML = this.cartItems.item_count > 9 ? '9+' : this.cartItems.item_count
          item.setAttribute('data-cart-count', this.cartItems.item_count)
        })

        if (index === 0 && secondProduct) {
          let product = JSON.parse(secondProduct.querySelector('#free-products').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const variant of product.variants) {
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                isSecondInCart = true;
                break
              }
            }
          }

          if (isSecondInCart) {
            document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
          }
        }

        for (let i = 0; i < this.cartItems.items.length; i++) {
          const item = this.cartItems.items[i]
          for (const variant of this.freeProductData) {
            if (item.variant_id === variant.id && item.final_line_price === 0) {
              this.hasFreeProductInCart = true;
              this.freeProductIndex = i + 1
              break
            }
          }
        }

        const firstProduct = document.querySelectorAll('free-gift-product')[0]
        if (index === 1 && firstProduct) {
          let freeProductData = JSON.parse(firstProduct.querySelector('#free-product-variants').innerHTML)

          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i]
            for (const variant of freeProductData) {
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                isFirstInCart = true;
                break
              }
            }
          }

          //when first product in cart, show the progress bar for second product
          //add based on customer feedback

          if (isFirstInCart && document.querySelectorAll('.tier-four')) {
            const tierFourElements = document.querySelectorAll('.tier-four');

            tierFourElements.forEach(function (element) {
              element.style.display = "flex";
            });
          }
        }

        // 如果购物车金额达到了free gift的金额
        if (this.cartTotalPrice >= this.freeProductAmount) {
          // 如果购物车里面没有
          if (!this.hasFreeProductInCart) {
            // 如果只有一个variants
            if (this.freeProductData.length === 1 && this.freeGiftJson.addType === 'auto') {
              loading = true
              CartJS.addItem(this.freeProductData[0].id)
            } else {
              // this.style.display = 'block'
              // if (index === 0) {
              this.style.display = 'block'
              // } else if (isFirstInCart ) {
              //   this.style.display = 'block'
              // }
              if (this.freeGiftJson.variantType !== 'select') {
                this.querySelectorAll('.free-gift-varitant-btn').forEach(item => item.classList.remove('disabled'))
              } else {
                this.querySelector('.free-gift-select')?.classList.remove('disabled')
              }

              if (this.freeGiftJson.addToType == 'add-btn') {
                this.querySelectorAll('#free-product-btn').forEach(item => {
                  item.classList.remove('disabled')
                })
              }
            }
          } else {
            this.style.display = 'none'
            if (index === 0 && isFirstInCart)
              document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
            else if (index === 1 && this.hasFreeProductInCart)
              document.querySelector('#one-bar-text').innerHTML = document.querySelector('#one-bar-text').innerHTML.replace(' Add to bag below.', '')
          }
        } else if (this.hasFreeProductInCart && this.freeProductAmount > this.cartTotalPrice) {
          // this.style.display = 'block'
          // if (index === 0) {
          this.style.display = 'block'
          // } else if (isFirstInCart) {
          //   this.style.display = 'block';
          // }
        } else {
          // this.style.display = 'block'
          // if (index === 0) {
          //   this.style.display = 'block'
          // } else if (isFirstInCart) {
          this.style.display = 'block'
          // }
        }

        // if (this.querySelectorAll('.carousel-cell').length > 1 && this.style.display === 'block') {
        //   this.flkty = new Flickity(this.querySelector('.free-gift-product-wrapper-swipe'), {
        //     cellAlign: 'left',
        //     prevNextButtons: true,
        //     contains: true,
        //     pageDots: false
        //   })
        // }
      }

      onAddBtnClick(event) {
        if (event.target.closest('#free-product-btn').classList.contains('free-gift-loading') || event.target.closest('#free-product-btn').classList.contains('disabled')) {
          return
        }

        let id = ''
        if (this.freeGiftJson.variantType === 'select' && this.querySelector('select')) {
          id = event.target.closest('select').value
        } else if (this.querySelectorAll('.free-gift-varitant-btn').length) {
          this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
            if (item.classList.contains('selected')) {
              id = item.getAttribute('data-var-id')
            }
          })
        } else {
          id = event.target.closest('#free-product-btn').getAttribute('data-var-id')
        }

        event.target.closest('#free-product-btn').classList.add('free-gift-loading')

        loading = true
        if (id) {
          CartJS.addItem(id)
        } else {
          CartJS.addItem(event.target.getAttribute('data-var-id'))
        }

        // if (!this.freeGiftJson.autoRemoveFirst) {
        //   return
        // }
        //
        // const index = Number(this.getAttribute('data-index'))
        // const productId = Number(this.getAttribute('data-first-id'))
        // if (index === 1) {
        //   const itemToRemove = this.cartItems.items.find(item => {
        //     return item.product_id === productId && item.final_line_price === 0
        //   })
        //
        //   if (itemToRemove) {
        //     CartJS.removeItemById(itemToRemove.variant_id)
        //   }
        // }
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        this.querySelectorAll('.free-gift-varitant-btn').forEach(item => {
          item.classList.remove('selected')
        })
        this.querySelector('.free-gift-product-buy')?.classList.remove('disabled')

        event.target.classList.add('selected')


        if (this.freeGiftJson.addToType !== 'add-btn') {
          loading = true
          CartJS.addItem(event.target.getAttribute('data-var-id'))
          event.target.closest('.free-gift-varitant-btn').classList.add('free-gift-loading')
        }
      }
    })
  }

  if (!customElements.get('additional-products')) {
    customElements.define('additional-products', class AdditionalProducts extends HTMLElement {
      constructor() {
        super()

        this.freeGiftJson = JSON.parse(this.querySelector('#additional-product-json').innerHTML)

        // Build seed-ID list: newest-added product first, then older cart items.
        // Falls back to legacy data-first-id if data-seed-ids is absent (cached HTML).
        const seedIds = (this.getAttribute('data-seed-ids') || this.getAttribute('data-first-id') || '')
          .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

        // Fetch a single (product_id, intent) combination. Resolves to the parsed
        // .product-recommendations element if it contained product cards, else null.
        // Leading slash is critical — original code used a relative URL, which
        // resolved to /products/recommendations/... (404) when the drawer was
        // opened from a PDP, and /collections/recommendations/... (404) from a
        // collection page. Those 404s silently fell through to the Trending
        // Wines fallback. See diagnosis in project memory.
        const fetchRec = function (productId, intent) {
          return fetch(`/recommendations/products?product_id=${productId}&limit=10&section_id=api-relate-products&intent=${intent}`)
            .then(function (response) { return response.text(); })
            .then(function (text) {
              const html = document.createElement('div');
              html.innerHTML = text;
              const rec = html.querySelector('.product-recommendations');
              const products = rec ? rec.querySelectorAll('.product-card') : [];
              return products.length > 0 ? rec : null;
            })
            .catch(function () { return null; });
        };

        // Walk fallback chain: each seed ID × each intent, stop on first non-empty
        // response. Sequential (not parallel) so we don't waste API calls when
        // the first attempt succeeds.
        const tryFallbackChain = async function () {
          const intents = ['related', 'complementary'];
          for (let i = 0; i < intents.length; i++) {
            for (let j = 0; j < seedIds.length; j++) {
              const rec = await fetchRec(seedIds[j], intents[i]);
              if (rec) return rec;
            }
          }
          return null;
        };

        tryFallbackChain().then((recommendations) => {
          if (recommendations) {
            this.querySelector('.additional-products-container').innerHTML =
              recommendations.querySelector('.additional-products-container').innerHTML
          }

          if (this.freeGiftJson.variantType === 'btn')
              this.querySelectorAll('.additional-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
            else {
              this.querySelectorAll('.free-gift-select select').forEach(item => item.addEventListener('change', (event) => {
                this.onVarBtnSelect(event)
              }))
            }

            if (this.querySelector('.add-btn')) {
              this.querySelectorAll('.add-btn').forEach(item => item.addEventListener('click', event => {
                if (item.classList.contains('disabled')) {
                  return
                }

                let id = ''
                if (event.target.classList.contains('add-btn')) {
                  event.target.classList.add('free-gift-loading')
                  id = event.target.getAttribute('data-var-id')
                } else {
                  event.target.parentNode.classList.add('free-gift-loading')
                  id = event.target.parentNode.getAttribute('data-var-id')
                }

                loading = true
                CartJS.addItem(id)
              }))
            }

            this.onCartUpdate()
            // if (document.querySelector('.main-carousel')) {
            document.querySelectorAll('.main-carousel').forEach(item => {
              flkty = new Flickity(item, {
                cellAlign: 'left',
                prevNextButtons: true,
                contain: true,
                pageDots: false
              });
              flkty.resize()
            })

            setTimeout(() => {
              this.style.opacity = '1'
            }, 200)
          });

      }

      cartItems = {}
      freeGiftJson = {}

      onCartUpdate() {
        this.cartItems = JSON.parse(this.querySelector('#additional-cart-json').innerHTML)
        let count = 0
        this.querySelectorAll('.additional-product-card').forEach(card => {
          const id = Number(card.getAttribute('data-product-id'))
          if (!this.cartItems.items.find(item => item.product_id === id) && count < this.freeGiftJson.number) {
            card.style.display = 'flex'
            count += 1
          } else {
            card.style.display = 'none'
            card.parentNode.removeChild(card)
          }
        })
        if (count === 0) {
          this.style.display = 'none'
        }
      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        const id = event.target.getAttribute('data-var-id')
        // event.target.parentNode.parentNode.parentNode.parentNode.style.display = 'none'
        loading = true
        CartJS.addItem(id)
        event.target.closest('.additional-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  if (!customElements.get('upsell-item')) {
    customElements.define('upsell-item', class UpsellItem extends HTMLElement {
      constructor() {
        super()

        this.variantType = this.getAttribute('data-variant-type')
        this.cartItems = JSON.parse(this.querySelector('#cart-json').innerHTML)

        if (this.variantType === 'btn')
          this.querySelectorAll('.upsell-variants-btn').forEach(item => item.addEventListener('click', (event) => this.onVarBtnClick(event)))
        else
          this.querySelector('.free-gift-select select')?.addEventListener('change', (event) => this.onVarBtnSelect(event))


        this.querySelector('.add-btn')?.addEventListener('click', event => {
          let id = ''
          if (event.target.classList.contains('add-btn')) {
            event.target.classList.add('free-gift-loading')
            id = event.target.getAttribute('data-var-id')
          } else {
            event.target.parentNode.classList.add('free-gift-loading')
            id = event.target.parentNode.getAttribute('data-var-id')
          }

          loading = true
          CartJS.addItem(id)
        })

        this.querySelector('.upsell-item-close')?.addEventListener('click', () => {
          this.style.display = 'none'
        })

        this.onCartUpdate()
      }

      cartItems = {}
      addToType = ''
      variantType = ''

      onCartUpdate() {
        if (!this.cartItems.items.find(item => item.product_id === Number(this.getAttribute('data-product-id'))) && !localStorage.getItem(`upsell-hide-${this.getAttribute('data-product-id')}-${this.getAttribute('data-cart-id')}`)) {
          this.querySelector('.product-card').style.display = 'flex'
          this.style.display = 'block'
        } else {
          this.style.display = 'none'
          this.querySelector('.product-card').style.display = 'none'
        }


      }

      onVarBtnSelect(event) {
        const id = event.target.value
        event.target.closest('div').classList.add('free-gift-loading')
        CartJS.addItem(id)
      }

      onVarBtnClick(event) {
        if (loading) {
          return
        }

        const id = event.target.getAttribute('data-var-id')
        loading = true
        CartJS.addItem(id)
        event.target.closest('.upsell-variants-btn').classList.add('free-gift-loading')
      }
    })
  }

  let completeTimeout = null
  let noRefresh = false

  $(document).on('cart.requestComplete', (event, cart) => {
    if (completeTimeout || window.displayUpgrade) {
      return
    }
    if (window.noCartRefresh) {
      window.noCartRefresh = false
      noRefresh = true
    }

    completeTimeout = setTimeout(() => {
      fetch('/cart?section_id=api-cart-drawer')
        .then((response) => response.text())
        .then((response) => {
          // document.querySelector('#cart-drawer').innerHTML = response
          if (!noRefresh) {
            document.body.style.overflow = ""
            document.querySelector('#cart-drawer .drawer__inner').innerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.drawer__inner').innerHTML
            document.querySelector('#cart-drawer').classList.remove('is-loading')
            if (!document.querySelector('#cart-drawer').classList.contains('is-drawer-open')) {
              toggleCart()
            } else {
            }
          } else {
            document.querySelector('#cart-drawer .cart__price__holder').innerHTML =
              new DOMParser().parseFromString(response, 'text/html')
                .querySelector('.cart__price__holder').innerHTML

            document.querySelector('#cart-drawer .callout-label').innerHTML =
              new DOMParser().parseFromString(response, 'text/html')
                .querySelector('.callout-label').innerHTML

            document.querySelector('#cart-drawer .cart__price__holder .cart__total:last-child').style.opacity = '1'
            document.querySelector('checkout-btn').classList.remove('free-gift-loading')
          }

          document.querySelectorAll('.free-gift-loading').forEach(item => item.classList.remove('free-gift-loading'))
        })

      fetch('/cart.js')
        .then((response) => response.json())
        .then((response) => {
          document.querySelectorAll('.header__cart-count')
            .forEach(item => {
              let count = response.item_count
              // const protectionId = Number(item.getAttribute('data-order-protection-id'))
              //
              // for (const item of response.items) {
              //   if (item.product_id === protectionId) {
              //     count--
              //   }
              // }
              item.innerHTML = count
            })
        })
      completeTimeout = null
    }, 100)
  })
})
